module.exports = __webpack_public_path__ + "static/img/6.e089d0c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/3/eng/6.png
// module id = OxGq
// module chunks = 0